import { Component, OnInit, Input } from '@angular/core';
import { countDecimals } from '../models';
import { IContentElementFrame } from './model';
import { TextToSpeechService } from '../text-to-speech.service';

@Component({
  selector: 'element-render-frame',
  templateUrl: './element-render-frame.component.html',
  styleUrls: ['./element-render-frame.component.scss']
})
export class ElementRenderFrameComponent implements OnInit {

  @Input() element:IContentElementFrame;
  @Input() isLocked: boolean;
  @Input() questionState: any;

  constructor(
    public text2Speech: TextToSpeechService,
  ) { }

  isToggledOn:boolean = true;
  rotation:number = 0;
  height: number
  pointerEvents:boolean = true;
  isResponded: boolean;

  ngOnInit() {
    if (this.element.isOff){
      if (!this.isLocked){
        this.isToggledOn = false;
      }
    }
  }

  handleHeightChange(inc:number, {maxHeight, roundingTolerance}) {
    if (this.height != 0 && !this.height) this.height = this.element.height;
    if (this.height != 0 && !this.height) this.element.height = 0;
    this.height += inc;
    if (this.height<0) this.height = 0;
    if (maxHeight && 
      maxHeight != undefined && 
      this.height>maxHeight) this.height = maxHeight;
    if(roundingTolerance != undefined || roundingTolerance != null){
      this.height = parseFloat(this.height.toFixed(countDecimals(roundingTolerance)))
    } 
  }

  handleRotate(angle: number) {
    this.rotation += angle;
  }

  handleToggle(toggleState:boolean){
    this.isToggledOn = toggleState;
  }

  handleClickable(pointerEvents: boolean) {
    console.log(pointerEvents)
    this.pointerEvents = pointerEvents
  }

  getHeight() {
    if (this.height || this.height==0) {
      return this.height
    }
    return undefined
  }

  renderRotation() {
    return `rotate(${this.rotation}deg)`;
  }

  getPointerEvents(){
    return this.pointerEvents ? 'auto' : 'none'
  }

  getStyle() {
    let style = this.element.styleRaw
    if (!style) {
      style = {}
    }
    style = JSON.parse(JSON.stringify(style))
    if (style["filter"]) {
        const index = style["filter"].toString().indexOf("invert(1)")
        if (index!=-1) {
            style["filter"] = style["filter"].toString().replace("invert(1)", '')
        }
    }
    return style
  }

}
